import React from 'react';
import View from './view';
import {useSelector} from 'react-redux';
import {profileECardInfoSelector} from '../../../../redux/selectors/profile';

export const ECardInfo = () => {
  const eCardInfo = useSelector(profileECardInfoSelector());
  if (!eCardInfo) {
    return null;
  }
  return <View eCardInfo={eCardInfo} />;
};
